import { NotFound } from "@coworker/apprestructured/src/task-management/components/NotFound/NotFound";
import { TaskCreatorAndEditorSheetSettingsSection } from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/TaskCreatorAndEditorSheetSettingsSection/TaskCreatorAndEditorSheetSettingsSection";
import React, { memo } from "react";
import {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import CreatorFragmentConfig from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragmentConfig";
import { NewOrExistingFile } from "@coworker/apprestructured/src/shared/types/newOrExistingFile";
import { useTranslation } from "@coworker/locales";
import { TaskCreatorAndEditorSheetDetailsSection } from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/TaskCreatorAndEditorSheetDetailsSection/TaskCreatorAndEditorSheetDetailsSection";
import styles from "./TaskCreatorAndEditorSheetContent.module.css";

interface TaskCreatorAndEditorSheetContentProps {
  showNotFound: boolean;
  notFoundTitle: string;
  notFoundMessage: string;
  creatorFragmentCommonProps: CreatorFragmentCommonProps;
  isLoadingCreatorFragments: boolean;
  detailsCreatorFragments: CreatorFragmentConfig[];
  scheduleComponent: React.ReactNode;
  images: NewOrExistingFile[];
  onImagesChange: (newImages: NewOrExistingFile[]) => void;
  isDisabled: boolean;
  files: NewOrExistingFile[];
  onFilesChange: (newFiles: NewOrExistingFile[]) => void;
  setCreatorFragmentRef?: (
    key: string
  ) => (element: CreatorFragmentHandle | null) => void;
}

export const TaskCreatorAndEditorSheetContent = memo(
  (props: TaskCreatorAndEditorSheetContentProps) => {
    const {
      showNotFound,
      notFoundTitle,
      notFoundMessage,
      creatorFragmentCommonProps,
      setCreatorFragmentRef,
      isLoadingCreatorFragments,
      scheduleComponent,
      detailsCreatorFragments,
      isDisabled,
      images,
      onImagesChange,
      files,
      onFilesChange,
    } = props;
    const { t } = useTranslation();
    if (showNotFound) {
      return <NotFound title={notFoundTitle} message={notFoundMessage} />;
    } else {
      return (
        <div className={styles["sheetsContent"]}>
          <TaskCreatorAndEditorSheetDetailsSection
            headerTitle={t("taskDetailsString")}
            isLoadingCreatorFragments={isLoadingCreatorFragments}
            creatorFragments={detailsCreatorFragments}
            creatorFragmentCommonProps={creatorFragmentCommonProps}
            setCreatorFragmentRef={setCreatorFragmentRef}
          />
          <TaskCreatorAndEditorSheetSettingsSection
            setCreatorFragmentRef={setCreatorFragmentRef}
            headerTitle={t("taskSettingsString")}
            creatorFragmentCommonProps={creatorFragmentCommonProps}
            scheduleComponent={scheduleComponent}
            images={images}
            onImagesChange={onImagesChange}
            isDisabled={isDisabled}
            files={files}
            onFilesChange={onFilesChange}
          />
        </div>
      );
    }
  }
);
